import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom'; // useHistory'i burada içe aktarın
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Contact from '../../component/Section/Contact';
import Head from '../../component/Section/Head';
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { Box, Button, MobileStepper, Paper } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const maxDots = 15; // Örnek olarak 10 nokta sınırı

const serviceData = [
  {
    id: "1",
    img: "./../../images/as1.png",
    desc: "Panel Çit",
    images: [
        "./../../images/panelçit (1).png",
        "./../../images/panelçit (2).png",
        "./../../images/panelçit (3).png",
        "./../../images/panelçit (4).png",
        "./../../images/panelçit (5).png",
        "./../../images/panelçit (6).png",
        "./../../images/panelçit (7).png",
        "./../../images/panelçit (8).png",
  

  
      ],
    title: "Panel Çit Nedir? Panel çit sınır belirleyici özelliğinin yanı sıra çevre güvenliğini de sağlayan ve aynı zamanda her mekana dekoratif ve estetik görsellik kazandıran bir tel örgü sistemidir. Panel Çit Özellikleri Panel çit, tel örgülü yapısından dolayı simetrik, şık ve dekoratif bir görünüme sahip olan panel çitlerin tel kaplamaları, statik boyanın galvaniz üzerine uygulanması ile yapılmaktadır.",
  },
  {
    id: "2",
    img: "./../../images/kanatlı kapı (37).jpg",
    desc: "Kapı Sistemleri",
    title: "Panel çit kapı, panel çit uygulamaları ile oluşturulan alana giriş çıkış sağlamak amacıyla yerleştirilen yada güvenli alanlar için güvenlik noktası olarak belirlenen kapılardır. Panel çit kapılar standart ya da ihtiyacınıza uygun ölçülerde hazırlanmakta olup, belirlenmiş olan dış yada iç mekan alana kolayca uygulanabilmektedir.",
    images: [
        "./../../images/kapı (1).png",
        "./../../images/kapı (2).png",
        "./../../images/kapı (3).png",
        "./../../images/kapı (4).png",
        "./../../images/kapı (5).png",
        "./../../images/kapı (6).png",
        "./../../images/kapı (7).png",
        "./../../images/kapı (8).png",
        "./../../images/kapı (9).png",
        "./../../images/kapı (10).png",
        "./../../images/kapı (11).png",
        "./../../images/kapı (12).png",
        "./../../images/kapı (13).png",

        
      ], 
},
  {
    id: "3",
    img: "./../../images/telçit (9).png",
    desc: "Tel Çit Sistemleri",
    title: "Tel çit sistemleri sınırları belli olan bir bölge temel alınarak, o sınırlar içerisinde bulunan başka bir alanla çakışma yaşama gibi bir durumun engellenmek istenmektedir. Bu amaçla bir bölge ile sınır belirlemek ya da o bölgeyi korumak, bölgenin kendisine ait bir araziye sahip olduğunu gösterebilmek için kullanılmakta olan çevreleme sistemlerine tel çit sistemleri adı verilmektedir.",
    images: [
        "./../../images/telçit (1).png",
        "./../../images/telçit (2).png",
        "./../../images/telçit (3).png",
        "./../../images/telçit (4).png",
        "./../../images/telçit (5).png",
        "./../../images/telçit (6).png",
        "./../../images/telçit (7).png",
        "./../../images/telçit (8).png",
        "./../../images/telçit (9).png",
        "./../../images/telçit (10).png",
        "./../../images/telçit (11).png",
        "./../../images/telçit (12).png",
   
        
      ]
},
  {
    id: "4",
    img: "./../../images/panoçit (1).png",
    desc: "Pano Çit",
    title: "Genellikle kare ve dikdörtgen şeklinde kullanılan pano çit, isteğe göre değişik şekil ve boyutlarda yapılmaktadır. Pano çit, alan düzenlemelerinin yapılmasından sonra zemin ya da duvar üzerine eşit aralıklarla, önceden hazırlanan köşebent çerçeve içerisine çit hasırlı veya örgü telli panolar monte edilerek yapılmaktadır.",
    images: [
        "./../../images/panoçit (1).png",
        "./../../images/panoçit (2).png",
        "./../../images/panoçit (3).png",


      ]
},
  {
    id: "5",
    img: "./../../images/dekoraçit (4).png",
    desc: "Dekoraçim",
    title: "Çim çit Dekoraçim, dekoratif, dayanıklı ve sağlam yapısı ile günümüzde oldukça sık tercih edilen bir çim çit türüdür. Çim ve çit’in birleşiminden meydana gelen ürün dekoraçim adı ile bilinmektedir.",
    images: [
        "./../../images/dekoraçit (1).png",
        "./../../images/dekoraçit (2).png",
        "./../../images/dekoraçit (3).png",
        "./../../images/dekoraçit (4).png",
        "./../../images/dekoraçit (5).png",
        "./../../images/dekoraçit (6).png",
        "./../../images/dekoraçit (7).png",
        "./../../images/dekoraçit (8).png",
        "./../../images/dekoraçit (9).png",
        "./../../images/dekoraçit (10).png",
 
        
      ]
},
  {
    id: "6",
    img: "./../../images/zemin.webp",
    desc: "Zemin Kaplamaları",
    title: "Zemin kaplama malzemelerinden biri olan, Landspace Peyzaj Halıları; estetik görüntü olarak ve pratik bir kullanım açısından oldukça sık tercih edilmektedir. İşyeri, restoran, kafeterya açık mekan doğal görünümlü olan yerlerde, profesyonel halı saha ve lig sahaları için oldukça sık bir biçimde tercih edilmektedir.",
    images: [
      "./../../images/zemin.webp",
        
      ]
},
  {
    id: "7",
    img: "./../../images/sporsahası.jpg",
    desc: "Spor Sahaları",
    title: "Eymen Tel Çit çatısı altında bütün spor sahaları yapımı ürünleri ve çeşitleri mevcuttur. Spor sahası yapımında uzmanlaşmış kadrosuyla Demirhan, açık ve kapalı spor sahaları kısa bir sürede anahtar teslim olarak inşa etmektedir.",
    images: [
      "./../../images/sporsahası.jpg",
      
        
      ]
},
  {
    id: "8",
    img: "./../../images/sporekipmanları.jpg",
    desc: "Spor Ekipmanları",
    title: "Tel çit sistemleri ve spor sahaları sektöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor ekipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
    images: [
      "./../../images/sporekipmanları.jpg",
        
      ]

},
{
  id: "9",
  img: "./../../images/sürgülü kapı (1).jpg",
  desc: "Sürgülü Kapılar",
  title: "Çevre güvenliğinizi en üst seviyeye taşıyan panel çit kapılarımızla tanışın! Firmamız, özel tasarım panel çit kapılarıyla mülkünüzü korumak ve erişimi kontrol altında tutmak için hizmetinizde. Estetik görünümü modern teknolojiyle birleştirerek ürettiğimiz kapılarımız, sağlamlığı ve uzun ömürlü kullanımı bir araya getiriyor. Profesyonel ekip ve yaratıcı tasarımlarımızla size özel çözümler sunuyoruz.",
  images: [
    "./../../images/sürgülü kapı (1).jpg",
    "./../../images/sürgülü kapı (2).jpg",
    "./../../images/sürgülü kapı (3).jpg",
    "./../../images/sürgülü kapı (4).jpg",
    "./../../images/sürgülü kapı (5).jpg",
    "./../../images/sürgülü kapı (6).jpg",
    "./../../images/sürgülü kapı (7).jpg",
    "./../../images/sürgülü kapı (8).jpg",
    "./../../images/sürgülü kapı (9).jpg",
    "./../../images/sürgülü kapı (10).jpg",
    "./../../images/sürgülü kapı (11).jpg",
    "./../../images/sürgülü kapı (12).jpg",
    "./../../images/sürgülü kapı (13).jpg",
    "./../../images/sürgülü kapı (14).jpg",
    "./../../images/sürgülü kapı (15).jpg",
    "./../../images/sürgülü kapı (16).jpg",
    "./../../images/sürgülü kapı (17).jpg",
    "./../../images/sürgülü kapı (18).jpg",
    "./../../images/sürgülü kapı (19).jpg",
    "./../../images/sürgülü kapı (20).jpg",
    "./../../images/sürgülü kapı (21).jpg",
    "./../../images/sürgülü kapı (22).jpg",
    "./../../images/sürgülü kapı (23).jpg",
    "./../../images/sürgülü kapı (24).jpg",
    "./../../images/sürgülü kapı (25).jpg",
    "./../../images/sürgülü kapı (26).jpg",
    "./../../images/sürgülü kapı (27).jpg",
    "./../../images/sürgülü kapı (28).jpg",
    "./../../images/sürgülü kapı (29).jpg",
    "./../../images/sürgülü kapı (30).jpg",
    "./../../images/sürgülü kapı (31).jpg",
    "./../../images/sürgülü kapı (32).jpg",
    "./../../images/sürgülü kapı (33).jpg",
    "./../../images/sürgülü kapı (34).jpg",
    "./../../images/sürgülü kapı (35).jpg",
    "./../../images/sürgülü kapı (36).jpg",
    "./../../images/sürgülü kapı (37).jpg",
    "./../../images/sürgülü kapı (38).jpg",
    "./../../images/sürgülü kapı (39).jpg",
    "./../../images/sürgülü kapı (40).jpg",
    "./../../images/sürgülü kapı (41).jpg",
    "./../../images/sürgülü kapı (42).jpg",
    "./../../images/sürgülü kapı (43).jpg",
    "./../../images/sürgülü kapı (44).jpg",
    "./../../images/sürgülü kapı (45).jpg",
    "./../../images/sürgülü kapı (46).jpg",
    "./../../images/sürgülü kapı (47).jpg",
    "./../../images/sürgülü kapı (48).jpg",
    "./../../images/sürgülü kapı (49).jpg",
    "./../../images/sürgülü kapı (50).jpg",
    "./../../images/sürgülü kapı (51).jpg",
    "./../../images/sürgülü kapı (52).jpg",
    "./../../images/sürgülü kapı (53).jpg",
    "./../../images/sürgülü kapı (54).jpg",
    "./../../images/sürgülü kapı (55).jpg",
    "./../../images/sürgülü kapı (56).jpg",
    "./../../images/sürgülü kapı (57).jpg",
    "./../../images/sürgülü kapı (58).jpg",
    "./../../images/sürgülü kapı (59).jpg",
    "./../../images/sürgülü kapı (60).jpg",
    "./../../images/sürgülü kapı (61).jpg",
    "./../../images/sürgülü kapı (62).jpg",
    "./../../images/sürgülü kapı (63).jpg",
    "./../../images/sürgülü kapı (64).jpg",
    "./../../images/sürgülü kapı (65).jpg",
    "./../../images/sürgülü kapı (66).jpg",
    "./../../images/sürgülü kapı (67).jpg",
    "./../../images/sürgülü kapı (68).jpg",
    "./../../images/sürgülü kapı (69).jpg",
    "./../../images/sürgülü kapı (70).jpg",
    "./../../images/sürgülü kapı (71).jpg",
    "./../../images/sürgülü kapı (72).jpg",
    "./../../images/sürgülü kapı (73).jpg",
    "./../../images/sürgülü kapı (74).jpg",
    "./../../images/sürgülü kapı (75).jpg",
    "./../../images/sürgülü kapı (76).jpg",
    "./../../images/sürgülü kapı (77).jpg",
    "./../../images/sürgülü kapı (78).jpg",
    "./../../images/sürgülü kapı (79).jpg",
    "./../../images/sürgülü kapı (80).jpg",
    "./../../images/sürgülü kapı (81).jpg",
    "./../../images/sürgülü kapı (82).jpg",
    "./../../images/sürgülü kapı (83).jpg",
    "./../../images/sürgülü kapı (84).jpg",
    "./../../images/sürgülü kapı (85).jpg",
    "./../../images/sürgülü kapı (86).jpg",
    "./../../images/sürgülü kapı (87).jpg",

    
  

      
    ]

},

{
  id: "10",
  img: "./../../images/döner.png",
  desc: "Dönerkapılar",
  title: "Tel çit sistemleri ve spor sahaları sektöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor ekipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
  images: [
    "./../../images/döner.png",
      
    ]

},

{
  id: "11",
  img: "./../../images/kanatlı kapı (34).jpg",
  desc: "Kanatlı Kapılar",
  title: "Tel çit sistemleri ve spor sahaları sektöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor ekipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
  images: [
    "./../../images/kanatlı kapı (1).jpg",
    "./../../images/kanatlı kapı (2).jpg",
    "./../../images/kanatlı kapı (3).jpg",
    "./../../images/kanatlı kapı (4).jpg",
    "./../../images/kanatlı kapı (5).jpg",
    "./../../images/kanatlı kapı (6).jpg",
    "./../../images/kanatlı kapı (7).jpg",
    "./../../images/kanatlı kapı (8).jpg",
    "./../../images/kanatlı kapı (9).jpg",
    "./../../images/kanatlı kapı (10).jpg",
    "./../../images/kanatlı kapı (11).jpg",
    "./../../images/kanatlı kapı (12).jpg",
    "./../../images/kanatlı kapı (13).jpg",
    "./../../images/kanatlı kapı (14).jpg",
    "./../../images/kanatlı kapı (15).jpg",
    "./../../images/kanatlı kapı (16).jpg",
    "./../../images/kanatlı kapı (17).jpg",
    "./../../images/kanatlı kapı (18).jpg",
    "./../../images/kanatlı kapı (19).jpg",
    "./../../images/kanatlı kapı (20).jpg",
    "./../../images/kanatlı kapı (21).jpg",
    "./../../images/kanatlı kapı (22).jpg",
    "./../../images/kanatlı kapı (23).jpg",
    "./../../images/kanatlı kapı (24).jpg",
    "./../../images/kanatlı kapı (25).jpg",
    "./../../images/kanatlı kapı (26).jpg",
    "./../../images/kanatlı kapı (27).jpg",
    "./../../images/kanatlı kapı (28).jpg",
    "./../../images/kanatlı kapı (29).jpg",
    "./../../images/kanatlı kapı (30).jpg",
    "./../../images/kanatlı kapı (31).jpg",
    "./../../images/kanatlı kapı (32).jpg",
    "./../../images/kanatlı kapı (33).jpg",
    "./../../images/kanatlı kapı (34).jpg",
    "./../../images/kanatlı kapı (35).jpg",
    "./../../images/kanatlı kapı (36).jpg",
    "./../../images/kanatlı kapı (37).jpg",
    "./../../images/kanatlı kapı (38).jpg",
    "./../../images/kanatlı kapı (39).jpg",
    "./../../images/kanatlı kapı (40).jpg",
    "./../../images/kanatlı kapı (41).jpg",

      
    ]

},

{
  id: "12",
  img: "./../../images/bahçe kapısı (1).jpg",
  desc: "Bahçe Kapıları",
  title: "Tel çit sistemleri ve spor sahaları sektöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor ekipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
  images: [
    "./../../images/bahçe kapısı (1).jpg",
    "./../../images/bahçe kapısı (2).jpg",
    "./../../images/bahçe kapısı (3).jpg",
    "./../../images/bahçe kapısı (4).jpg",
    "./../../images/bahçe kapısı (5).jpg",
    "./../../images/bahçe kapısı (6).jpg",
    "./../../images/bahçe kapısı (7).jpg",
    "./../../images/bahçe kapısı (8).jpg",
    "./../../images/bahçe kapısı (9).jpg",
    "./../../images/bahçe kapısı (10).jpg",
    "./../../images/bahçe kapısı (11).jpg",
    "./../../images/bahçe kapısı (12).jpg",
    "./../../images/bahçe kapısı (13).jpg",
    "./../../images/bahçe kapısı (14).jpg",
    "./../../images/bahçe kapısı (15).jpg",
    "./../../images/bahçe kapısı (16).jpg",
    "./../../images/bahçe kapısı (17).jpg",
    "./../../images/bahçe kapısı (18).jpg",
    "./../../images/bahçe kapısı (19).jpg",
    "./../../images/bahçe kapısı (20).jpg",
      
    ]

},

{
  id: "13",
  img: "./../../images/otomatik.jpg",
  desc: "Otomatik Kapılar",
  title: "Tel çit sistemleri ve spor sahaları se ktöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor e kipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
  images: [
    "./../../images/otomatik.jpg",
      
    ]

},
{
  id: "14",
  img: "./../../images/boru (1).jpg",
  desc: "Boru direk",
  title: "Eymen Tel Çit Sistemleri olarak, boru direk çit sistemleri ile güvenlik ve işlevselliği bir araya getiriyoruz. Boru direklerin sağlamlığı ve pratikliği, çit sistemlerimizin temelini oluşturuyor. Bu sistemler, mülkünüzü güvende tutarken çevresine uyumlu bir görünüm katıyor. Estetik tasarım ve sağlam yapı, boru direk çit sistemlerimizin temel özelliklerindendir.",
   images: [
    "./../../images/boru (1).jpg",
    "./../../images/boru (2).jpg",
    "./../../images/boru (3).jpg",
    "./../../images/boru (4).jpg",
    "./../../images/boru (5).jpg",
    "./../../images/boru (6).jpg",
    "./../../images/boru (7).jpg",
    "./../../images/boru (8).jpg",
    "./../../images/boru (9).jpg",
    "./../../images/boru (10).jpg",
    "./../../images/boru (11).jpg",
    "./../../images/boru (12).jpg",
    "./../../images/boru (13).jpg",
    "./../../images/boru (14).jpg",
    "./../../images/boru (15).jpg",
    "./../../images/boru (16).jpg",
    "./../../images/boru (17).jpg",
    "./../../images/boru (18).jpg",
    "./../../images/boru (19).jpg",
    "./../../images/boru (20).jpg",
    "./../../images/boru (21).jpg",
    "./../../images/boru (22).jpg",
    "./../../images/boru (23).jpg",

      
    ]

},
{
  id: "15",
  img: "./../../images/beton (15).jpg",
  desc: "Beton Direk",
  title: "Eymen Tel Çit Sistemleri olarak, beton direk çit sistemleriyle güvenliği bir adım öteye taşıyoruz. Beton direklerin sağlamlığı ve dayanıklılığı, mülkünüzü en iyi şekilde korumak için etkili bir çözüm sunar. Estetik tasarımımız ile güçlü güvenlik özelliklerini bir araya getirerek hem göz alıcı hem de koruyucu bir çit sistemi sunuyoruz.",
    images: [
    "./../../images/beton (1).jpg",
    "./../../images/beton (2).jpg",
    "./../../images/beton (3).jpg",
    "./../../images/beton (4).jpg",
    "./../../images/beton (5).jpg",
    "./../../images/beton (6).jpg",
    "./../../images/beton (7).jpg",
    "./../../images/beton (8).jpg",
    "./../../images/beton (9).jpg",
    "./../../images/beton (10).jpg",
    "./../../images/beton (11).jpg",
    "./../../images/beton (12).jpg",
    "./../../images/beton (13).jpg",
    "./../../images/beton (14).jpg",
    "./../../images/beton (15).jpg",
    "./../../images/beton (16).jpg",
    "./../../images/beton (17).jpg",
    "./../../images/beton (18).jpg",
    "./../../images/beton (19).jpg",
    "./../../images/beton (20).jpg",
    "./../../images/beton (21).jpg",
    "./../../images/beton (22).jpg",
    "./../../images/beton (23).jpg",
    "./../../images/beton (24).jpg",
    "./../../images/beton (25).jpg",
    "./../../images/beton (26).jpg",
    "./../../images/beton (27).jpg",
    "./../../images/beton (28).jpg",
    "./../../images/beton (29).jpg",
    "./../../images/beton (30).jpg",
    "./../../images/beton (31).jpg",
    "./../../images/beton (32).jpg",
    "./../../images/beton (33).jpg",
    "./../../images/beton (34).jpg",
    "./../../images/beton (35).jpg",
    "./../../images/beton (36).jpg",
    "./../../images/beton (37).jpg",
    "./../../images/beton (38).jpg",
    "./../../images/beton (39).jpg",
    "./../../images/beton (40).jpg",
    "./../../images/beton (41).jpg",
    "./../../images/beton (42).jpg",
    "./../../images/beton (43).jpg",
    "./../../images/beton (44).jpg",
    "./../../images/beton (45).jpg",
    "./../../images/beton (46).jpg",
    "./../../images/beton (47).jpg",
    "./../../images/beton (48).jpg",
    "./../../images/beton (49).jpg",
    "./../../images/beton (50).jpg",
    "./../../images/beton (51).jpg",
    "./../../images/beton (52).jpg",
    "./../../images/beton (53).jpg",
    "./../../images/beton (54).jpg",
    "./../../images/beton (55).jpg",
    "./../../images/beton (56).jpg",
    "./../../images/beton (57).jpg",
    "./../../images/beton (58).jpg",
    "./../../images/beton (59).jpg",
    "./../../images/beton (60).jpg",
    "./../../images/beton (61).jpg",
    "./../../images/beton (62).jpg",
    "./../../images/beton (63).jpg",
    "./../../images/beton (64).jpg",
    "./../../images/beton (65).jpg",
    "./../../images/beton (66).jpg",
    "./../../images/beton (67).jpg",
    "./../../images/beton (68).jpg",
    "./../../images/beton (69).jpg",
    "./../../images/beton (70).jpg",
    "./../../images/beton (71).jpg",
    "./../../images/beton (72).jpg",
    "./../../images/beton (73).jpg",
    "./../../images/beton (74).jpg",
    "./../../images/beton (75).jpg",
    "./../../images/beton (76).jpg",
    "./../../images/beton (77).jpg",
    "./../../images/beton (78).jpg",
    "./../../images/beton (79).jpg",
    "./../../images/beton (80).jpg",
    "./../../images/beton (81).jpg",
    "./../../images/beton (82).jpg",
    "./../../images/beton (83).jpg",
    "./../../images/beton (84).jpg",
    "./../../images/beton (85).jpg",
    "./../../images/beton (86).jpg",
    "./../../images/beton (87).jpg",
    "./../../images/beton (88).jpg",
    "./../../images/beton (89).jpg",
    "./../../images/beton (90).jpg",
    "./../../images/beton (91).jpg",
    "./../../images/beton (92).jpg",
    "./../../images/beton (93).jpg",
    "./../../images/beton (94).jpg",
    "./../../images/beton (95).jpg",




      
    ]

},
{
  id: "16",
  img: "./../../images/demir (1).jpg",
  desc: "Demir Direk",
  title: "Eymen Tel Çit Sistemleri olarak, demir direk çit sistemleriyle güvenliği en yü ksek standartlarda sağlıyoruz. Sağlam demir direkler, mülkünüzü etkili bir şekilde korumanın temelini oluştururken, çeşitli tasarım seçenekleri ile çevrenizle uyumlu bir görünüm sunar. Estetik açıdan çekici tasarım ve dayanıklı yapı, demir direk çit sistemlerimizin öne çıkan özelliklerindendir.",
  images: [
    "./../../images/demir (1).jpg",
    "./../../images/demir (2).jpg",
    "./../../images/demir (3).jpg",
    "./../../images/demir (4).jpg",
    "./../../images/demir (5).jpg",
    "./../../images/demir (6).jpg",
    "./../../images/demir (7).jpg",
    "./../../images/demir (8).jpg",
    "./../../images/demir (9).jpg",
    "./../../images/demir (10).jpg",
    "./../../images/demir (11).jpg",
    "./../../images/demir (12).jpg",
    "./../../images/demir (13).jpg",
    "./../../images/demir (14).jpg",
    "./../../images/demir (15).jpg",
    "./../../images/demir (16).jpg",
    "./../../images/demir (17).jpg",
    "./../../images/demir (18).jpg",
    "./../../images/demir (19).jpg",
    "./../../images/demir (20).jpg",
    "./../../images/demir (21).jpg",
    "./../../images/demir (22).jpg",
    "./../../images/demir (23).jpg",
    "./../../images/demir (24).jpg",
    "./../../images/demir (25).jpg",
    "./../../images/demir (26).jpg",
    "./../../images/demir (27).jpg",
    "./../../images/demir (28).jpg",
    "./../../images/demir (29).jpg",
    "./../../images/demir (30).jpg",
    "./../../images/demir (31).jpg",
    "./../../images/demir (32).jpg",
    "./../../images/demir (33).jpg",
    "./../../images/demir (34).jpg",
    "./../../images/demir (35).jpg",
    "./../../images/demir (36).jpg",
    "./../../images/demir (37).jpg",

      
    ]

},








  // Diğer servisleri buraya ekleyebilirsiniz
];
const DetailService = () => {
  const history = useHistory(); // useHistory'i burada kullanın

  // ...(diğer kodlar)

  const [isTelCitiSubMenuOpen, setIsTelCitiSubMenuOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const { id } = useParams();
  const selectedService = serviceData.find((item) => item.id === id);

  const toggleTelCitiSubMenu = () => {
    setIsTelCitiSubMenuOpen(!isTelCitiSubMenuOpen);
  };

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="position-relative">
          <img src="./../../images/Bg.png" className="images__wrap-head" alt="" />
          <div className="wrapper__bg-head"></div>
          <Navbar />
          <Head default="home" current="SERVİSLERİMİZ DETAY" title={"SERVİSLERİMİZ DETAY"} />
        </div>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4 mb-4 mb-md-0">
                <h3 className='medium font__size--20 text__20-1024 text-uppercase mb-3'>SERVİSLERİMİZ DETAY</h3>

                <ul className='list__menu-side'>
                  <li>
                    <NavLink to={`/servislerimiz/detay/1`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>
                      PANEL ÇİT
                    </NavLink>
                  </li>

                  <li className={`submenu-item ${isSubMenuOpen ? 'active-submenu' : ''}`}>
                    <a className='normal font__size--16 text__20-1024 roboto' onClick={toggleSubMenu}>
                      KAPI SİSTEMLERİ {isSubMenuOpen ? '▲' : '▼'}
                    </a>
                    {isSubMenuOpen && (
                      <ul className="submenu">
                        <li><NavLink to={`/servislerimiz/detay/9`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Sürgülü Kapılar</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/10`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Döner Kapılar</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/11`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Kanatlı Kapılar</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/12`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Bahçe Kapısı</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/13`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Otomatik Kapılar</NavLink></li>

                        {/* Diğer alt kategori öğeleri buraya eklenebilir */}
                      </ul>
                    )}
                  </li>
                  {/* ...(diğer kodlar) */}
                  <li className={`submenu-item ${isTelCitiSubMenuOpen ? 'active-submenu' : ''}`}>
                    <a className='normal font__size--16 text__20-1024 roboto' onClick={toggleTelCitiSubMenu}>
                      TEL ÇİT SİSTEMLERİ {isTelCitiSubMenuOpen ? '▲' : '▼'}
                    </a>
                    {isTelCitiSubMenuOpen && (
                      <ul className="submenu">
                        {/* Tel Çit Sistemleri alt kategori öğeleri */}
                        <li><NavLink to={`/servislerimiz/detay/15`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Beton Direk</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/14`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Boru Direk</NavLink></li>
                        <li><NavLink to={`/servislerimiz/detay/16`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>Demir Direk</NavLink></li>
                        {/* Diğer alt kategori öğeleri */}
                      </ul>
                    )}
                  </li>

                  <li><NavLink to={`/servislerimiz/detay/4`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>PANO ÇİT</NavLink></li>
                  <li><NavLink to={`/servislerimiz/detay/5`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>DEKORAÇİM ÇİT</NavLink></li>
                  <li><NavLink to={`/servislerimiz/detay/6`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>ZEMİN KAPLAMA</NavLink></li>
                  <li><NavLink to={`/servislerimiz/detay/7`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>SPOR SAHALARI</NavLink></li>
                  <li><NavLink to={`/servislerimiz/detay/8`} className='normal font__size--16 text__20-1024 roboto' onClick={handleLinkClick}>SPOR EKİPMANLARI</NavLink></li>
                </ul>
              </div>
              <div className="col-md-8">
                <img src={selectedService?.img} className='images__dt-service mb-4' alt="" />

                <h3 className='bold font__size--32 text__32-1024 mb-3 text-uppercase'>{selectedService?.desc}</h3>

                <p className='normal roboto font__size--16 text__20-1024 color__gray-1 lh-2 mb-3'>{selectedService?.title}</p>
                <p className='normal roboto font__size--16 text__20-1024 color__gray-1 lh-2 mb-3'>{selectedService?.title2}</p>

                <div className="wrapper__left-line mb-3">
                  <div className='normal roboto font__size--20 text__20-1024 color__gray-1 lh-2 pl-4'>

                  </div>
                </div>

                <p className='normal roboto font__size--16 text__20-1024 color__gray-1 lh-2 mb-5'></p>

                <h3 className='bold font__size--20 text__20-1024 mb-3 text-uppercase'>Çit Sistemlerinin Avantajlar</h3>

                <ul className='list__detail-info'>
                  <li>
                    <div className="d-flex align-items-start">
                      <img src="./../../images/asas.png" className='object-fit-content mt-2' alt="" />
                      <p className='ml-3 normal roboto font__size--16 text__20-1024 color__gray-1 lh-2'>Güvenlik: Tel çit sistemleri, mülkünüzü fiziksel olarak koruyarak izinsiz girişleri engeller. Yüksek kaliteli malzemelerden üretilen tel çitler, dayanıklılık ve direnç sunar.</p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-start">
                      <img src="./../../images/asas.png" className='object-fit-content mt-2' alt="" />
                      <p className='ml-3 normal roboto font__size--16 text__20-1024 color__gray-1 lh-2'>Görünürlük ve Estetik: Tel çitler, açık tasarımı sayesinde çevrenizdeki görünürlüğü engellemez. Bu, güvenliği artırırken estetik açıdan da hoş bir görüntü sunar.</p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-start">
                      <img src="./../../images/asas.png" className='object-fit-content mt-2' alt="" />
                      <p className='ml-3 normal roboto font__size--16 text__20-1024 color__gray-1 lh-2'>Çeşitlilik: Tel çit sistemleri, farklı güvenlik ihtiyaçlarına uyum sağlamak üzere çeşitli tipte ve boyutta bulunabilir. Özel tasarım seçenekleri, mekanınıza en uygun çözümü seçmenizi sağlar.</p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-start">
                      <img src="./../../images/asas.png" className='object-fit-content mt-2' alt="" />
                      <p className='ml-3 normal roboto font__size--16 text__20-1024 color__gray-1 lh-2'>Ekonomik: Diğer güvenlik alternatiflerine göre maliyet açısından avantajlı olan tel çit sistemleri, yüksek performans sunarken bütçenizi sarsmaz.</p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-start">
                      <img src="./../../images/asas.png" className='object-fit-content mt-2' alt="" />
                      <p className='ml-3 normal roboto font__size--16 text__20-1024 color__gray-1 lh-2'>Kolay Montaj ve Bakım: Profesyonel ekipler tarafından kolayca monte edilebilen tel çitler, düşük bakım gereksinimleri sayesinde uzun ömürlüdür.</p>
                    </div>
                  </li>
                </ul>

                <Box sx={{ maxWidth: 800, flexGrow: 1 }}>
                  <Paper
                    square
                    elevation={0}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      height: 50,
                      pl: 2,
                      bgcolor: 'background.default',
                    }}
                  ></Paper>

                  <AutoPlaySwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={activeStep}
                    onChangeIndex={handleStepChange}
                    enableMouseEvents
                  >
                    {selectedService?.images?.map((row, index) => (
                      <div key={"photo" + index}>
                        {Math.abs(activeStep - index) <= maxDots / 2 ? (
                          <Box
                            component="img"
                            className={'images__dt-service mb-4'}
                            src={row}
                            alt={"photo" + index}
                          />
                        ) : null}
                      </div>
                    ))}
                  </AutoPlaySwipeableViews>
                  <MobileStepper
                    steps={Math.min(selectedService?.images?.length || 0, maxDots)} // Resim sayısı veya maksimum nokta sayısından küçük olanını kullanın
                    position="static"
                    activeStep={activeStep}
                    nextButton={
                      <Button
                        size="small"
                        onClick={handleNext}
                        disabled={activeStep === Math.min((selectedService?.images?.length || 0) - 1, maxDots - 1)}
                      >
                        {theme.direction === 'rtl' ? (
                          <KeyboardArrowLeft />
                        ) : (
                          <KeyboardArrowRight />
                        )}
                        İLERİ
                      </Button>
                    }
                    backButton={
                      <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                          <KeyboardArrowRight />
                        ) : (
                          <KeyboardArrowLeft />
                        )}
                        GERİ
                      </Button>
                    }
                  />
                </Box>
              </div>
            </div>
          </div>
        </section>

        <Contact />

        <Footer />
      </div>
    </Fragment>
  );
};

export default DetailService;
